import { cn } from "@lib/cn"
import type { HTMLAttributes } from "react"

/**
 * The one card shell (PRD-60 chunk 0), identical to the professor SPA's.
 * Roles, not palette steps: a component that writes `dark:bg-slate-800` on a
 * card is bypassing the token layer. The `shadow-sm` halo the console used
 * to stack on top of the border is gone; `shadow-raised` carries an offset.
 *
 * Cards do not nest. A panel inside a card is an `Inset`.
 */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("rounded-card border-border bg-surface shadow-raised border", className)}
      {...props}
    />
  )
}

/** A sunken region INSIDE a card. The answer to "I need a card in a card". */
export function Inset({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("rounded-control bg-inset", className)} {...props} />
}

export function CardHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("border-hairline border-b p-4", className)} {...props} />
}

export function CardBody({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("p-4", className)} {...props} />
}

export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("border-hairline border-t p-4", className)} {...props} />
}
